import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { Container } from '../global'

const GetStarted = () => {
  return (
    <ContainerWrapper>
      <MainContainer>
        <h4>Mission</h4>
        <Subtext>
          The motivation behind making this as my project for DIGH3812A is due
          my interest in learning more about Indigenous History. I believe that
          I have forgotten most of what I learned within school since I was
          taught at a younger age and the knowledge was not persistent in my
          life. I personally believe this is an important topic because it gives
          us insight into the dark history of Canada that many may choose to
          forget. There are still survivers of the IRS(Indigenous Residential
          School) in Canada and learning about this history allows us to
          reconcile and understand the cause of many mental health issues
          prevalent within the Indigenous population. Please read more{' '}
          <Link to="/mission">here</Link> for more of my opinions on presenting
          this material
        </Subtext>
        <StartButton to="/start">Start Learning</StartButton>
      </MainContainer>
    </ContainerWrapper>
  )
}

export default GetStarted

const ContainerWrapper = styled.div`
  background-color: ${props => props.theme.color.background.light};
  position: relative;
  min-height: 50vh;
  @media (max-width: ${props => props.theme.screen.md}) {
    height: 65vh;
  }
`

const MainContainer = styled(Container)`
  padding: 40px 0 80px 0;
  @media (max-width: ${props => props.theme.screen.xs}) {
    padding: 80px 20px 80px 20px;
  }
  text-align: center;
`

const Subtext = styled(Container)`
  font-size: 16px;
  line-height: 40px;
  height: 100%;
  @media (max-width: ${props => props.theme.screen.xs}) {
    padding: 0 20px 20px 20px;
  }
  margin-bottom: 50px;
`

const StartButton = styled(Link)`
  background: white;
  border: 2px solid black;
  cursor: pointer;
  margin: 0.5rem;
  padding: 0.5em 0.75em;
  position: relative;
  text-transform: uppercase;
  color: black;
  text-decoration: none;
`
